<ng-template #preHeader>
    <shared-disabled-text>SIGN IN /</shared-disabled-text> SIGN UP
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Create your profile
</shared-auth-header>
<ng-template #description>
    Create a profile to remember your details and favourite orders for fast re-ordering next visit.
</ng-template>

<shared-form-for-sign-up [detachFormSubmitControls]="detachFormSubmitControls" [modal]="true"
    [cellNumber]="mobilePhone$ | async" [member]="member$ | async"></shared-form-for-sign-up>